export default {"src":"/_next/static/media/banner.f96eaafb.svg","height":700,"width":1200,"blurWidth":0,"blurHeight":0};